import React, { useEffect } from 'react';
import {
  Route,
  Router,
  Switch,
  Redirect,
  useRouteMatch,
  useHistory,
} from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { PageError } from 'components/shared';
import { GOOGLE_ANALYTICS_KEY } from 'shared/constants/index';
import ClerkScreenView from 'views/ClerkScreen';
import PageLoader from 'components/shared/PageLoader';
import TechScreenView from 'views/TechScreen';
import NPALayoutAuctioneer from 'views/AuctioneerScreen';
import { NPALayoutLarge as FloorToteLarge } from './views/FloorBidderScreen/NPALayoutLarge';
import { NPALayoutSmall as FloorToteSmall } from './views/FloorBidderScreen/NPALayoutSmall';
import { Wrapper, Body } from './assets/Styles';
import Login from './views/Login';
import ProtectedRoute from './ProtectedRoute';
import { useGARouteChangeTracker } from 'hooks';
import useStores from './hooks/use-store';
import { CacheBuster } from './CacheBuster';

const App = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const { WebSocketStore } = useStores();

  useGARouteChangeTracker(GOOGLE_ANALYTICS_KEY);

  const error = false;

  const { reconnecting } = WebSocketStore;

  if (reconnecting) return <PageLoader />;

  if (error) return <PageError />;

  return (
    <CacheBuster
      currentVersion={window.localStorage.getItem('cacheVersion')}
      isEnabled={true}
      isVerboseMode={true}
    >
      <Wrapper>
        <Body>
          <Router
            history={history}
            basename={process.env.PUBLIC_URL}
            key={Math.random()}
          >
            <Switch>
              <Route exact path="/login">
                <Login />
              </Route>
              <Route exact path="/">
                <Redirect to="/login" />
              </Route>
              <ProtectedRoute exact path="/clerk" component={ClerkScreenView} />
              <ProtectedRoute
                exact
                path="/tote-small"
                component={FloorToteSmall}
              />
              <ProtectedRoute
                exact
                path="/tote-large"
                component={FloorToteLarge}
              />
              <ProtectedRoute
                exact
                path="/auctioneer"
                component={NPALayoutAuctioneer}
              />
              <ProtectedRoute exact path="/tech" component={TechScreenView} />
            </Switch>
          </Router>
        </Body>
        {match.isExact && <Redirect to={`${match.url}`} />}
      </Wrapper>
    </CacheBuster>
  );
};

export default observer(App);
